<template>
  <div class="min-h-screen bg-gradient-to-b from-soft-white to-lavender-tint/20">
    <div class="container mx-auto px-6 py-12 max-w-5xl">
      <h1 class="text-4xl md:text-5xl font-poppins font-bold text-dark-gray mb-3">{{ title }}</h1>
      <p class="text-lg text-dark-gray/70 mb-10 max-w-2xl">{{ intro }}</p>
      <div class="grid sm:grid-cols-2 gap-4">
        <RouterLink
          v-for="item in items"
          :key="item.to"
          :to="item.to"
          class="card-neumorphic !p-5 hover:translate-y-[-2px] transition"
        >
          <h2 class="font-semibold text-dark-gray mb-1">{{ item.label }}</h2>
          <p class="text-sm text-dark-gray/60">{{ item.hint }}</p>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import {
  breadcrumbSchema,
  graphSchema,
  organizationSchema,
  useSeo,
} from '../composables/useSeo'

export default {
  name: 'HubPage',
  props: {
    title: String,
    seoTitle: String,
    intro: String,
    path: String,
    description: String,
    items: { type: Array, default: () => [] },
  },
  setup(props) {
    useSeo(
      computed(() => ({
        title: props.seoTitle || `${props.title} | Homvisit Kerala Phlebotomy`,
        description: props.description || props.intro,
        path: props.path,
        keywords: [props.title, 'Homvisit Kerala'],
        schema: graphSchema([
          organizationSchema(),
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: props.title, path: props.path },
          ]),
        ]),
      }))
    )
  },
}
</script>
